import { CancellationReasonAdapters } from '../adapters';
import { CancellationReasonsApi } from '../clients';
import { IGetCancellationReasonsPayload, IGetCancellationReasonsResult } from '../types';

export const getCancellationReasons = async (
  payload?: IGetCancellationReasonsPayload,
): Promise<IGetCancellationReasonsResult> => {
  const response = await CancellationReasonsApi.getCancellationReasons(payload);

  return CancellationReasonAdapters.toGetCancellationReasonsResult(response);
};
